import type { Theme } from '../../themes/themes';

export const createDialogTheme = (theme: Theme): Partial<Theme> => ({
  components: {
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          padding: theme.spacing(0),
          '&:not(:last-child)': {
            marginBottom: theme.spacing(5),
            [theme.breakpoints.up('lg')]: {
              marginBottom: theme.spacing(6),
            },
          },
          // Increase margin-right, so text cannot underflow close button
          '.PortalsCloseButton-Button + &': {
            marginRight: theme.spacing(8),
            [theme.breakpoints.up('lg')]: {
              marginRight: theme.spacing(9),
            },
          },
        },
      },
      defaultProps: {
        variant: 'h3',
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          padding: theme.spacing(0),
          '&:not(:last-child)': {
            marginBottom: theme.spacing(5),
            [theme.breakpoints.up('lg')]: {
              marginBottom: theme.spacing(6),
            },
          },
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        root: {
          '.MuiPaper-root': {
            padding: theme.spacing(5),
            borderRadius: theme.spacing(4),
            [theme.breakpoints.up('sm')]: {
              padding: theme.spacing(7),
            },
            [theme.breakpoints.up('md')]: {
              padding: theme.spacing(9),
            },
            [theme.breakpoints.up('lg')]: {
              padding: theme.spacing(10),
            },
          },
          '.PortalsCloseButton-Button': {
            position: 'absolute',

            top: '12px',
            right: '12px',
            [theme.breakpoints.up('sm')]: {
              top: '24px',
              right: '24px',
            },
            [theme.breakpoints.up('md')]: {
              top: '36px',
              right: '36px',
            },
            [theme.breakpoints.up('lg')]: {
              top: '40px',
              right: '40px',
            },
          },
        },
      },
    },
  },
});
